// utils.js
const addIdToData = (data) => {
    return data.map((item, index) => ({
        ...item,
        id: index + 1
    }));
}
export default addIdToData